import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import * as uiActions from 'modules/ui';
import * as dataActions from 'modules/fetchData';
import styled from 'styled-components';
import { Flex } from 'lib/style-utils';
import MainCarousel from 'components/Home/MainCarousel';
import WinMainCarousel from 'components/Home/WinMainCarousel';

import Insta from 'components/Home/Insta';
import SubCarousel from 'components/Home/SubCarousel';
import Bottom from 'components/Home/Bottom';
import Spinner from 'react-md-spinner';

const SpinnerWrapper = Flex.extend`
  width: 100%;
  height: 100vh;
`;

class Home extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  componentDidMount() {
    const { DataActions, homeData } = this.props;

    if (!homeData.toJS().mainCarousel1.url) {
      DataActions.getHome();
    }
  }

  render() {
    const ua = (navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Chrome') > -1) || (navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Safari') > -1) || (navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Mobile') > -1);
    const { color, homeData, loading } = this.props;

    const CarouselWrapper = styled.div`
        position: relative;
    `;

    return (
      <div>
        <Helmet>
          <title>베이비디디 - BABY DEEDEE</title>
        </Helmet>
        {
          loading ?
          (
            <SpinnerWrapper>
              <Spinner size="60px"/>
            </SpinnerWrapper>
          ) :
          (
            <div>
              <CarouselWrapper>
                {ua ? <MainCarousel color={color} homeData={homeData.toJS()}/> : <WinMainCarousel color={color} homeData={homeData.toJS()}/>}
              </CarouselWrapper>
              <Insta homeData={homeData.toJS()}/>
              <SubCarousel color={color} homeData={homeData.toJS()}/>
              <Bottom/>
            </div>
          )
        }
      </div>
    );
  }
}

export default connect(
  (state) => ({
    color: state.ui.get('color'),
    homeData: state.fetchData.get('home'),
    loading: state.pender.pending['fetch/GET_HOME']
  }),
  (dispatch) => ({
    UIActions: bindActionCreators(uiActions, dispatch),
    DataActions: bindActionCreators(dataActions, dispatch)
  })
)(Home);



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js